<template>
  <div>
    <div class="step-show-box">
      <div class="step-box">
        <!-- <swiper ref="mySwiper" :options="stepSwiper">

          <swiper-slide v-for="item, index in processes" :key="index"> -->
            <div class="step clearfix" v-for="item, index in processes" :key="index">
              <div class="left">
                <div class="circle-contianer">
                  <div :class="['circle', item.isActive ? 'active-circle' : '']">
                    <img :src="item.step_icon" alt="" />
                  </div>
                </div>
                <p class="txt">Step {{ index + 1 }}</p>
                <p :class="['info', item.isActive ? 'active-info' : '']">{{ item.name }}</p>
                <span v-if="item.label === 'person_question' || item.label === 'team_registration'">（线上）</span>
                <span v-if="item.label === '64'">（线下）</span>
              </div>
              <!-- <div class="line" v-show="item.has_next"></div> -->
            </div>
          <!-- </swiper-slide>

        </swiper>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import { swiper, swiperSlide } from "vue-awesome-swiper";
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
export default {
  data() {
    return {
      processs: [],
      stepSwiper: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        freeMode: true,
        paginationClickable: true,
        spaceBetween: 0,
        centeredSlides: true,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        watchOverflow: true,
        resistanceRatio: 0,
        observer: true,
        slidesPerView: 'auto',
      },
    };
  },
  // components: {
  //   Swiper,
  //   SwiperSlide
  // },
  computed: {
  },
  methods: {
    timestampToTime(timestamp) {
      // 时间戳为10位需*1000，时间戳为13位不需乘1000
      var date = new Date(timestamp * 1000);
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      return Y + M + D ;
    }
  },
  watch: {
    'processes'() {
      // console.log(this.processes)
    }
  },
  mounted() {
    
  },
  props: ['processes', 'unit', 'next']
};
</script> 

<style scoped>
.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  display: none;
}

.swiper-button-prev,
.swiper-button-next {

  color: #733085;
}

.swiper-wrapper {
  width: 100%;
}

.swiper-container {
  --swiper-theme-color: #ff6600;
  /* 设置Swiper风格 */
  --swiper-navigation-color: #00ff33;
  /* 单独设置按钮颜色 */
  --swiper-navigation-size: 25px;
  /* 设置按钮大小 */
  width: 100%;
  height: 100%;
}

/* .main .step-show-box::-webkit-scrollbar {
  display: none; /* Chrome Safari */
/* } */


.step-box{
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 40px;
  position: relative;
  height: 100%;
}
.step-box>*{
  position: relative;
  z-index: 2;
}
.step-box:before{
  content: "";
  position: absolute;
  left: 68px;
  right: 68px;
  height: 3px;
  top: 72px;
  background: #EEEEEE;
}
.step-box .swiper-slide {
  width: auto !important;
}
.main .step-show-box {
  width: 100%;
  background: #FFFFFF;
  margin: 30px auto;
}

.step .left {
  text-align: center;
}

.step .circle-contianer{
  padding: 0 15px;
  background-color: #fff;
  display: inline-block;
}

.step-box .circle {
  width: 68px;
  line-height: 60px;
  height: 68px;
  background-color: #e3d6e7;
  border-radius: 50%;
  border: 4px solid #e3d6e7;
  text-align: center;
}

.step-box .circle img {
  text-align: center;
  width: 50%;
  height: 50%;
  object-fit: contain;
}

/* 进行到圆圈样式 */
.step-box .active-circle {
  background-color: #733085;
}

.step-box .line {
  margin-top: 77px;
  float: left;
  width: 100px;
  margin-left: 10px;
  margin-right: 10px;
  height: 3px;
  background: #EEEEEE;
}

.step-box .txt {
  margin: 13px 0 8px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #828487;
}

.step-box .info {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

/* 进行到文字样式 */
.step-box .active-info {
  font-weight: 600;
  color: #733085;
}
.swiper-button-next{
    display: none;
  }
@media screen and (max-width: 991px){
  .swiper-button-next{
    display: block;
  }
}
@media screen and (max-width: 767px) {
  .main .step-show-box{
    margin: 0;
    background: unset;
  }
  .step .circle-contianer{
    background-color: #f8f8f8;
  }
  .step-box{
    padding: 30px 15px;
  }
  .step-box:before{
    height: 1px;
    top: 50px;
    background-color: #ccc;
  }
  .step-box .step{
    flex: 1;
    padding: 0 3px;
  }
  .step .circle-contianer{
    padding: 0 5px;
  }
  .step-box .circle{
    width: 40px;
    height: 40px;
    line-height: 36px;
    border-width: 2px;
  }
  .step-box .circle img{
    width: 18px;
    height: 18px;
    object-fit: cover;
  }
  .step-box .info,
  .step-box .active-info{
    font-size: 13px;
  }
  .step-box .txt{
    margin: 10px 0 8px;
    font-size: 12px;
  }
}
</style>
